import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import * as L from "leaflet";
import 'leaflet-draw';
import { SupervisorService } from '../service/supervisor.service';
declare var require: any
const PREFIX_IMAGE_RELATIVE_PATH = '../../../../assets/img/dispatcher-map-images/';
@Component({
	selector: "app-root",
	templateUrl: "./test.component.html",
	styleUrls: ["./test.component.css"]
})
export class TestComponent implements OnInit{
  api_key = "wly6pnqvmbuioatp8an1zigi6n3h6mntxr5c4mxw";
  responseData;
  supervisorID;
  token;
  showLegned = false
  apiMarkersLayer: L.FeatureGroup; // Feature group to store API markers
  constructor(private route: ActivatedRoute, private http: HttpClient,private service:SupervisorService) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      console.log('input route params', params['params']);
      console.log('input route params', params['params']['id']);
      this.token = params['params']['token']
      this.supervisorID = params['params']['id']
    })

    const container = document.getElementById('map')
     let map = L.map(container).setView([-30.5595,22.9375], 8);
    L.tileLayer("https://api.maps.geoint.africa/v1/"+this.api_key+"/tile/{x}/{y}/{z}.png?settings=global-decarta_TT").addTo(map);
    var editableLayers = new L.FeatureGroup();
    var downloadEditableLayers = new L.FeatureGroup();
    map.addLayer(editableLayers);
    
    // Initialize feature group for API markers
    this.apiMarkersLayer = new L.FeatureGroup();
    map.addLayer(this.apiMarkersLayer);

    const drawControl = new L.Control.Draw({
      // position: "topright",
    draw: {
     polygon: {
       allowIntersection: false, // Restricts shapes to simple polygons
       drawError: {
         color: '#e1e100', // Color the shape will turn when intersects
         message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
       },
       shapeOptions: {
         color: '#97009c'
       }
       },
      polyline: false,
      marker: false,
      circlemarker: false,
      rectangle:false
    },
    edit: {
     featureGroup: editableLayers,
     },
    });
    //map.addControl(drawControl);

  // this.supervisorID = "1232b09a-9944-4ed1-9e59-a61eec00d677";
//  this.token = "U2FsdGVkX18b7GrfFR7GqlklRcfwUn9Up4aEdQy2EPUbqEyVEkaLqaNAEe34oTzAt4vFmRcBmjWgMNEqKKNB3g";

if(this.supervisorID && this.token) {
  this.mapDetails(map);
  setInterval(() => {
  this.mapDetails(map);
},30000)
}


  }

  mapDetails(map){
    this.service.getPosts(this.supervisorID,this.token)
  .subscribe(response => {
    console.log('api response', response);
    if(response['isSuccess'] && response['statusCode'] == 200){
      // Clear existing markers from previous API call
      this.apiMarkersLayer.clearLayers();
      
      this.responseData = '';
     this.responseData = response['resources'];
     console.log('api responseData', this.responseData);
     if(this.responseData['vehicles']){
      for ( var i = 0; i < this.responseData.vehicles.length; ++i ){
      var popup = '<br/><b>Name:</b> '+ this.responseData.vehicles[i]["displayName"] +
                  '<br/><b>Sub Area:</b> ' + this.responseData.vehicles[i]["subArea"]  +
                  '<br/><b>vehicle Reg Number:</b> ' + this.responseData.vehicles[i]["vehicleRegistrationNumber"]  +
                  '<br/><b>Coordinates:</b> ' + this.responseData.vehicles[i]["latitude"] +',' + this.responseData.vehicles[i]["longitude"]

        // var m = L.marker( [this.response Data.vehicles[i].latitude, this.responseData.vehicles[i].longitude], {icon: icons[this.responseData.vehicles[i]["cssClassName"]]}).addTo(map)
        // .bindPopup( popup );

        const icon = L.icon({
          //iconUrl: require(`../../assets/img/dispatcher-map-images/${this.responseData.sites[i].iconName}`),
          iconUrl: `${PREFIX_IMAGE_RELATIVE_PATH}${this.responseData.vehicles[i]?.iconName}`,


        });
        var m = L.marker( [this.responseData.vehicles[i]?.latitude, this.responseData.vehicles[i]?.longitude], {icon: icon}).addTo(this.apiMarkersLayer)
        .bindPopup( popup );
    }
    }
    if(this.responseData['sites']){
      for ( var i = 0; i < this.responseData.sites.length; ++i ){
        var popup = '<br/><b>Name:</b> '+ this.responseData.sites[i]["displayName"] +
                    '<br/><b>Address:</b> ' + this.responseData.sites[i]["streetAddress"]  +
                    '<br/><b>Description:</b> ' + this.responseData.sites[i]["alarmDescription"]

          // var m = L.marker( [this.responseData.sites[i].latitude, this.responseData.sites[i].longitude], {icon: icons[this.responseData.sites[i]["cssClassName"]]}).addTo(map)
          // .bindPopup( popup );
          const icon = L.icon({
            //iconUrl: require(`../../assets/img/dispatcher-map-images/${this.responseData.sites[i].iconName}`),
            iconUrl: `${PREFIX_IMAGE_RELATIVE_PATH}${this.responseData.sites[i]?.iconName}`,

          });
          var m = L.marker( [this.responseData.sites[i]?.latitude, this.responseData.sites[i]?.longitude], {icon: icon}).addTo(this.apiMarkersLayer)
          .bindPopup( popup );
    }

      }

      if(this.responseData['lines']) {
        for (var i = 0; i < this.responseData.lines.length; ++i) {
          let pointA = new L.LatLng(
            this.responseData.lines[i].siteLatitude,
            this.responseData.lines[i].siteLongitude
          );
          let pointB = new L.LatLng(
            this.responseData.lines[i].vehicleLatitude,
            this.responseData.lines[i].vehicleLongitude
          );

          var polyline = new L.Polyline([pointA, pointB], {
            color: 'red',
            weight: 3,
            opacity: 0.5,
            smoothFactor: 1
          });
          polyline.addTo(this.apiMarkersLayer);
        }
        console.log('Polylines added to map');
      }

    }
  });
  }
  toggleLegend(){
    this.showLegned = !this.showLegned;
  }

//   getDateAndTime(dateObj) {
//     const now = new Date(dateObj);

// const date = now.getDate(); // Get the day of the month (1-31)
// const month = now.getMonth() + 1; // Get the month (0-11), add 1 to get the correct month
// const year = now.getFullYear(); // Get the full year (e.g., 2023)
// const hours = now.getHours(); // Get the hours (0-23)
// const minutes = now.getMinutes(); // Get the minutes (0-59)
// const seconds = now.getSeconds(); // Get the seconds (0-59)
// const formattedDateTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
// return formattedDateTime;
// // console.log(formattedDateTime);

//   }
    }
